"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.Types = void 0;
const _imports_1 = require("./_imports");
const _shared_1 = require("./_shared");
exports.Types = ['formula', 'tree'];
// Zod schemas for ReceivableAdvanceRate.Config
// Note: The tree structures are recursive. For JSON schema generation,
// we use z.any() for the recursive children since the full tree structure
// is already well-defined in the existing JSON schema.
// Simplified schema that captures the structure without recursive type complexity
const AdvanceRateModifierNodeSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    isMatch: _shared_1.FormulaConfigSchema,
    modifierFormula: _shared_1.FormulaConfigSchema,
    children: _imports_1.z.array(_imports_1.z.any()), // Recursive: children are AdvanceRateModifierNode[]
});
const AdvanceRateNodeSchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    isMatch: _shared_1.FormulaConfigSchema,
    advanceRate: _shared_1.FormulaConfigSchema,
    children: _imports_1.z.array(_imports_1.z.any()), // Recursive: children are AdvanceRateNode[]
    modifierNames: _imports_1.z.array(_imports_1.z.string()),
});
const FormulaSchema = _imports_1.z.object({
    type: _imports_1.z.literal('formula'),
    loanProductIds: _imports_1.z.array(_imports_1.z.string()),
    config: _shared_1.FullFormulaConfigSchema,
});
const TreeSchema = _imports_1.z.object({
    type: _imports_1.z.literal('tree'),
    loanProductIds: _imports_1.z.array(_imports_1.z.string()),
    root: AdvanceRateNodeSchema,
    modifiers: _imports_1.z.array(AdvanceRateModifierNodeSchema),
});
exports.ConfigSchema = _imports_1.z.discriminatedUnion('type', [
    FormulaSchema,
    TreeSchema,
]);
//# sourceMappingURL=ReceivableAdvanceRate.js.map